import styled from 'styled-components';

export const Description = styled.p`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 600;
    color: ${({ theme }) => theme.shades.white[70]};
    letter-spacing: -0.03em;
    font-size: 1rem;
    line-height: 1.2;
    margin: 0;
    padding: 0;
`;
